module.exports = __webpack_public_path__ + "img/mda_ico_5.a4db4f68.svg";